import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';

import Entry from 'layout/Entry/Entry';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
	//<React.StrictMode>
	<Entry />,
	//</React.StrictMode>,
);

reportWebVitals();
